import { render, staticRenderFns } from "./LeadsCardRoute.vue?vue&type=template&id=8ba87c32&scoped=true&"
import script from "./LeadsCardRoute.vue?vue&type=script&lang=js&"
export * from "./LeadsCardRoute.vue?vue&type=script&lang=js&"
import style0 from "./LeadsCardRoute.vue?vue&type=style&index=0&id=8ba87c32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba87c32",
  null
  
)

export default component.exports